import React from 'react';
import defaultImage from '../../assets/modal/FanZone-Generic.jpg';

function AnchorPortrait(props) {
  const { styles, anchor, isDiscountPage } = props;

  if (!isDiscountPage) {
    return (
      <React.Fragment>
        <div
          className={styles.fanZoneAnchor}
          style={{ backgroundImage: `url(${anchor.joinOverlay || defaultImage})` }}
        >

          <div className={styles.anchorDesc}>{anchor.description}</div>
          <div className={styles.tint} />
        </div>
        <div className={styles.anchorName}>{anchor.name}</div>
      </React.Fragment>
    );
  }

  return (
    <div
      className={styles.fanZoneAnchor}
      style={{ backgroundImage: `url(${anchor.joinOverlay || defaultImage})` }}
    >
      <div className={styles.anchorName}>{anchor.name}</div>
      <div className={styles.anchorDesc}>{anchor.description}</div>
      <div className={styles.tint} />
    </div>
  );
}

export default AnchorPortrait;
